import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const CATEGORY_PATH = "/category/v1";

export const getCategoryApi = async (params = {}, options = {}) =>
  await getRequest(CATEGORY_PATH, params, options);

export const getCategoryByIdApi = async (id) =>
  await getRequest(`${CATEGORY_PATH}/${id}`);

export const addCategoryApi = async (body) =>
  await postRequest(CATEGORY_PATH, body);

export const updateCategoryApi = async (body) =>
  await putRequest(`${CATEGORY_PATH}/${body?._id}`, body);

export const deleteCategoryByIdApi = async (id) =>
  await deleteRequest(`${CATEGORY_PATH}/${id}`);

export const getSubCategoriesApi = async (params = {}, options = {}) =>
  await getRequest(`${CATEGORY_PATH}/subcategories`, params, options);
